export function halves(){

  $('.modelComp4 .clicked').on('click',function(e){

        $(e.target).closest('.half').hide();
        let hidden = $(e.target).closest('.half').attr('class');
        $('.modelComp4 > div.half').each(function(){
          //$(this).show();
          if($(this).attr('class') != hidden){
                if($(window).width() > '1023'){
                    $(this).css("display", "flex") .hide() .fadeIn('slow');
                }else{
                    $(this).fadeIn('slow');

                }
          }
        });
      });

    }

//Incrementing the numerical value when the viewpoint is on the element
export function incrementNumericValue() {

  $.fn.isInViewport = function () {
      let elementTop = $(this).offset().top;
      let elementBottom = elementTop + $(this).outerHeight();

      let viewportTop = $(window).scrollTop();
      let viewportBottom = viewportTop + $(window).height();

      return elementBottom > viewportTop && elementTop < viewportBottom;
  };

  $(window).on("scroll", function () {
      $('.increment-numeric-value').each((i, el) => {
        let $counter = $(el);
          if (!$counter.isInViewport() || $counter.data('animation-started'))return;

          $counter.data('animation-started', true).prop('Counter', 0).animate({
              Counter: $counter.text()
          }, {
              duration: 1000,
              easing: 'swing',
              step: function (num) {
                  $counter.text(Math.ceil(num));
              }
          });
      });
  });
}